import React, { FunctionComponent } from "react";

import { FlexDirection, Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { MenuNavigationSectionType } from "../../navigation";
import { MenuPanelItemId } from "../../panelItems";
import { FormPanel } from "../FormPanel";
import { Logo } from "../Logo";
import { MenuExpandButton } from "../MenuExpandButton";
import { MenuPanelItem } from "../MenuPanelItem";
import { MenuScrollLayout } from "../MenuScrollLayout";
import { NotificationPanel } from "../NotificationPanel";
import { MenuPanelComponentProps } from "./MenuPanelComponentProps";

export { MenuPanelComponentProps };

const classNames = bemClassNames("menu-panel");

/** Panel menu umožňující otevírání sekcí */
export const MenuPanelComponent: FunctionComponent<MenuPanelComponentProps> = ({ wider }) => (
    <div className={classNames({ wider })}>
        <MenuScrollLayout
            // Bez usePaddedScrollbars by scrollbar překryl šipku kombinovaného tlačítka, na kterou by tak nešlo kliknout.
            usePaddedScrollbars={true}
            stickyHeaderContent={(
                <Logo qa="menu-logo-button" />
            )}
            stickyFooterContent={(
                <Layout
                    flexDirection={FlexDirection.column}
                    spacingSizeBottom={SpacingSize.xs}
                >
                    <MenuPanelItem id={MenuPanelItemId.user} section={MenuNavigationSectionType.static} qa="menu-user-button" />
                    <MenuExpandButton qa="menu-expand-button" />
                </Layout>
            )}
        >
            <Layout flexDirection={FlexDirection.column}>
                <MenuPanelItem id={MenuPanelItemId.quickAccess} section={MenuNavigationSectionType.static} qa="menu-quick-access-button" />
                <FormPanel />
                <NotificationPanel />
            </Layout>
        </MenuScrollLayout>
    </div>
);
